/* istanbul ignore file */

/* eslint-disable no-restricted-imports */
import {Theme} from '@veneer/core';
import {system} from '@veneer/system';
import {tokens} from '@veneer/tokens';

import {WolfPalette, WolfSpacings} from './types';

const wolfPalette: WolfPalette = {
    light: {
        ...system.palette.light,
        severities: {
            critical: system.palette.light.foreground.default,
            high: system.palette.light.negative.default,
            medium: system.palette.light.warning.default,
            low: tokens.color.gold4,
            safe: system.palette.light.positive.default,
            neutral: system.palette.light.foreground.disabled,
        },
    },
    dark: {
        ...system.palette.dark,
        severities: {
            critical: system.palette.dark.foreground.default,
            high: system.palette.dark.negative.default,
            medium: system.palette.dark.warning.default,
            low: tokens.color.gold3,
            safe: system.palette.dark.positive.default,
            neutral: system.palette.dark.foreground.disabled,
        },
    },
    highContrast: {
        ...system.palette.highContrast,
        severities: {
            critical: system.palette.highContrast.foreground.default,
            high: system.palette.highContrast.negative.default,
            medium: system.palette.highContrast.warning.default,
            low: tokens.color.gold3,
            safe: system.palette.highContrast.positive.default,
            neutral: system.palette.highContrast.foreground.disabled,
        },
    },
};

export const wolfSpacings: WolfSpacings = {
    high: {
        section: system.spacing.standard.padding.five,
    },
    standard: {
        section: system.spacing.standard.padding.six,
    },
};

export const getWolfPalette = (mode: Theme['mode']) => {
    switch (mode) {
        case 'light':
            return wolfPalette.light;
        case 'dark':
            return wolfPalette.dark;
        case 'contrast':
            return wolfPalette.highContrast;
    }
};
export const getWolfSpacings = (density: Theme['density']) => {
    switch (density) {
        case 'high':
            return wolfSpacings.high;
        case 'standard':
            return wolfSpacings.standard;
    }
};
